/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

export enum FIELD_CONTAINER_STYLE {
	TRANSPARENT = "transparent",
	BORDER = "border"
}

/**
 * Component props
 */
export interface IFieldContainerProps {
	/** Container visual style (defaults to TRANSPARENT) */
	style?: FIELD_CONTAINER_STYLE;
	/** Custom class name */
	className?: string;
}

/**
 * Component to display custom content in relation to fields (eg. is padded the same as row, etc...)
 *
 * @param props Component props
 */
export const FieldContainer: FC<IFieldContainerProps> = ({ children, style, className }) => {
	const baseClass = BEM("edt-field-container", undefined, {
		style: style || FIELD_CONTAINER_STYLE.TRANSPARENT
	});

	baseClass.add("edt-field-element");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("content").toClassName()}>{children}</div>
		</div>
	);
};
